import { _httpGet, _httpPost } from '@/service/index'
import type { ApiResponse } from '@/composables/useApi'

// 获取个人信息
export const getUserInfo = (data: any = {}) => _httpGet('/api/app/user/getUserInfo', data)

// 更新个人信息
export const updateUserInfo = (data: any = {}) => _httpPost('/api/app/user/updateUserInfo', data)

// 上传头像接口
export const uploadAvatar = (data: any = {}) => _httpPost('/api/app/user/uploadAvatar', data)

// 发送短信验证码
// TODO: 临时参数 xyz
export const smsCaptcha = (data: any) =>
  _httpPost('/api/app/user/smsCaptcha', { ...data, xyz: '861993085957532_1792648374' })

// 手机号登录（国内）
export const login = (data: any) => _httpPost('/api/app/user/login', data)

// 注销账号
export const deleteAccount = (data: any = {}) => _httpPost('/api/app/user/delete', data)

// 退出登录
export const logout = () => _httpGet('/api/app/user/logout')

// 网易云音乐解绑
export const unbindMusic = (data: any = {}) => _httpPost('/api/app/oauth/unbindMusic', data)

// 查询音乐授权状态
export const getMusicBindStatus = () => _httpGet('/api/app/oauth/getMusicBindStatus')

// 查询区号
export const getCountryCode = () => _httpGet('/api/app/phone/code')

// 协议更新状态：0-已同意无更新 1-用户协议更新 2-隐私协议更新 3-两者都更新
export type AgreementStatus = 0 | 1 | 2 | 3

// 用户协议查询结果
export interface AgreementInfo {
  content: string
  status: AgreementStatus
}

// 查询用户协议（变更内容 + 更新状态）
export const getAgreementInfo = (): Promise<ApiResponse<AgreementInfo>> =>
  _httpGet('/api/user/agreement/info')

// 同意用户协议
export const agreeAgreement = (): Promise<ApiResponse> => _httpPost('/api/user/agreement/agree')

// 保存紧急联系人
export const saveEmergencyContact = (data: {
  contactName: string
  countryCode: string
  phoneNumber: string
  smsCaptcha: string
}): Promise<ApiResponse> => _httpPost('/api/user/saveEmergencyContact', data)

